import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AutocompleteDto } from '@core/dto/auto-complete-dto';
import { AutocompleteService } from '@core/services/autocomplete.service';


@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
})
export class AutocompleteComponent implements OnInit {
  @Input() searchFor: 'nome' | 'descricao' | string = 'nome';
  @Input() form: FormGroup;
  @Input() disabled: boolean = false;
  @Input() name: string = '';
  @Input() id: string = '';
  @Input() customClass: any = '';
  @Input() url: any = '';
  @Input() params: any = {};
  @Input() customOptions: Array<any>;
  @Input() forbidden: any[] = [];
  @Input() fieldName = 'nome';
  @Input() key = 'id';

  @Output() onChange = new EventEmitter<any>();
  @Output() onClear = new EventEmitter<any>();
  @Output() onFocusOut = new EventEmitter<any>();
  @Output() onEnter = new EventEmitter<any>();

  options: AutocompleteDto[] = [];

  constructor(public autocompleteService: AutocompleteService) {}

  ngOnInit(): void {
    if (this.customOptions) {
      this.onValueChange();
      if (typeof this.form.get(this.name).value === 'string') this.selectToAutocomplete();
    }
  }

  onValueChange() {
    this.form.get(this.name).valueChanges.subscribe(value => {
      if (value && typeof value === 'string') {
        this.selectToAutocomplete();
      }
    });
  }

  selectToAutocomplete() {
    this.form.get(this.name).setValue(
      this.customOptions.find(
        (x) => x.value === this.form.get(this.name).value
      )
    );
  }

  getOptions(event?: any) {
    if (this.customOptions) {
      this.options = [...this.customOptions];
      if (event?.query) {
        this.options = [...this.customOptions].filter(
          (x) =>
            isNaN(x.value) &&
            x.value?.toUpperCase().includes(event.query.trim().toUpperCase()) ||
            x.name?.toUpperCase().includes(event.query.trim().toUpperCase())
        );
      }
      return;
    }

    this.autocompleteService
      .getForSelectFromObject(this.url, {
        [ this.searchFor ]: event?.query,
        ...this.params,
      })
      .subscribe((response) => {
        const filteredsOptions = response.filter(
          (item) =>
            !this.forbidden.find(
              (forbiddenItem) =>
                forbiddenItem &&
                forbiddenItem.id.includes(item.id) &&
                !forbiddenItem.id.includes(this.form.get(this.name).value?.id)
            )
        );
        this.options = filteredsOptions;
      });
  }

  get optionsForAutocomplete() {
    return this.options;
  }

  get idName() {
    return this.id ? this.id : this.name;
  }

  onKeyUp(event) {
    if (event.key == 'Enter') {
      this.onEnter.emit();
    }
  }
}
